import { css } from "../../../styled-system/css";

export const styles = {
  contentWrapper: () =>
    css({
      display: "flex",
      width: "100%",
      flexDirection: "column",
      rowGap: "0",
      columnGap: "baseUnit.mobile3",
      justifyContent: "center",
      desktop: {
        display: "flex",
        flexDirection: "row",
      },
      "& a": {
        textDecoration: "underline",
      },
    }),
  textWrapper: () =>
    css({
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      maxWidth: "100%",
      alignSelf: "center",
      desktop: {
        maxWidth: "528px",
      },
    }),
  titleWrapper: () =>
    css({
      alignSelf: "left",
      maxWidth: "initial",
      "& h2": {
        textAlign: "left",
        marginBottom: "baseUnit.mobile3",
      },
    }),
  subtitleWrapper: () =>
    css({
      alignSelf: "center",
      color: "ink",
      marginTop: "baseUnit.mobile3",
      marginBottom: "baseUnit.mobile3",
      marginLeft: 0,
      marginRight: 0,
      maxWidth: "initial",
      fontSize: "body.cat",
      lineHeight: "body.cat",
      desktop: {
        marginTop: 0,
        marginBottom: "baseUnit.mobile3",
        marginLeft: 0,
        marginRight: 0,
        fontSize: "body.horse",
        lineHeight: "body.horse",
      },
    }),
  imageWrapper: () =>
    css({
      alignSelf: "center",
      maxWidth: "640px",
      width: "100%",
      desktop: {
        maxWidth: "528px",
      },
      "& img": {
        width: "100%",
      },
    }),
};
